import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config';
import './agent.css';

function AuthPage() {
  var [isLogin, setIsLogin] = useState(true);
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [name, setName] = useState('');
  var [error, setError] = useState('');
  var [loading, setLoading] = useState(false);
  var confirmMsg = '';
  var navigate = useNavigate();

  // If already logged in, redirect straight to dashboard
  useEffect(function() {
    var token = localStorage.getItem('agent_token');
    if (!token) return;
    fetch(API_BASE_URL + '/api/projects', {
      headers: { Authorization: 'Bearer ' + token },
    }).then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.projects && d.projects.length > 0) {
          navigate('/agent/dashboard/' + d.projects[0].id, { replace: true });
        } else {
          navigate('/agent/onboarding', { replace: true });
        }
      })
      .catch(function() { localStorage.removeItem('agent_token'); });
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    var endpoint = isLogin ? '/api/auth/login' : '/api/auth/signup';
    var body = isLogin ? { email, password } : { email, password, name };

    try {
      var res = await fetch(API_BASE_URL + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Something went wrong');
        setLoading(false);
        return;
      }

      localStorage.setItem('agent_token', data.token);
      localStorage.setItem('agent_user', JSON.stringify(data.user));

      // Check if user already has a project
      var projRes = await fetch(API_BASE_URL + '/api/projects', {
        headers: { Authorization: 'Bearer ' + data.token },
      });
      var projData = await projRes.json();

      if (projData.projects && projData.projects.length > 0) {
        navigate('/agent/dashboard/' + projData.projects[0].id);
      } else {
        navigate('/agent/onboarding');
      }
    } catch (err) {
      setError('Network error');
    }
    setLoading(false);
  }

  return (
    <div className="agent-auth-page">
      <div className="agent-auth-card">
        <a href="/" className="agent-back-site">← Back to site</a>
        <h1 className="agent-auth-title">Marketing Agent</h1>
        <p className="agent-auth-sub">{isLogin ? 'Welcome back' : 'Create your account'}</p>

        <form onSubmit={handleSubmit} className="agent-auth-form">
          {!isLogin && (
            <input type="text" placeholder="Your name" value={name}
              onChange={function(e) { setName(e.target.value); }} className="agent-input" />
          )}
          <input type="email" placeholder="Email" value={email} required
            onChange={function(e) { setEmail(e.target.value); }} className="agent-input" />
          <input type="password" placeholder="Password" value={password} required minLength={6}
            onChange={function(e) { setPassword(e.target.value); }} className="agent-input" />

          {error && <p className="agent-error">{error}</p>}
          {confirmMsg && <p className="agent-confirm">{confirmMsg}</p>}

          <button type="submit" className="agent-btn-primary" disabled={loading}>
            {loading ? 'Please wait\u2026' : isLogin ? 'Log In' : 'Sign Up'}
          </button>
        </form>

        <p className="agent-auth-toggle">
          {isLogin ? "Don't have an account? " : 'Already have an account? '}
          <button type="button" className="agent-link-btn"
            onClick={function() { setIsLogin(!isLogin); setError(''); }}>
            {isLogin ? 'Sign Up' : 'Log In'}
          </button>
        </p>
      </div>
    </div>
  );
}

export default AuthPage;
